exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-sm td[data-v-e6934d40], .table-sm th[data-v-e6934d40]{\n  font-size: 95%;\n}\n.product-name[data-v-e6934d40] {\n  border-bottom: solid 2px #ccc;\n  padding-bottom: 5px;\n}\n.min-height[data-v-e6934d40] {\n  min-height: 250px;\n}\np[data-v-e6934d40] {\n  margin-bottom: 10px;\n}\n.carousel-indicators li[data-v-e6934d40] {\n  width: 23%;\n  height: 70px;\n  text-indent: 0;\n  overflow: hidden;\n  float: left;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.carousel-indicators[data-v-e6934d40] {\n  bottom: 0;\n  margin: 0;\n  position: relative;\n}\n.carousel-control-next[data-v-e6934d40],\n.carousel-control-prev[data-v-e6934d40] {\n  z-index: 100;\n}\n.zoom[data-v-e6934d40]:after {\n  display: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6934d40","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/product.vue
// module id = 363
// module chunks = 0